import { lazy } from "react"

import { useTranslation } from "react-i18next"
import { Navigate, type RouteObject } from "react-router"

import { GuestLayout } from "~/layouts/GuestLayout"
import { Layout } from "~/layouts/Layout"

import { routeMapper } from "~/helpers/route-mapper"

import { useBaseConfig } from "~/config/MyAccountConfigContext"

const VerifyCashRegisterRegistrationPage = lazy(() => import("~/pages/VerifyCashRegisterRegistrationPage"))

const PurchaseStatusPage = lazy(() => import("~/pages/purchase/PurchaseStatusPage"))
const VerificationPage = lazy(() => import("~/pages/VerificationPage"))
const LoyaltyPointsToDiscountPage = lazy(() => import("~/pages/LoyaltyPointsToDiscountPage"))
const NewsletterSubscribePage = lazy(() => import("~/pages/NewsletterSubscribePage"))
const ContactPage = lazy(() => import("~/pages/ContactPage"))
const SignUpSuccessPage = lazy(() => import("~/pages/SignUpSuccessPage"))
const UnsubscribePage = lazy(() => import("~/pages/UnsubscribePage"))
const GiftCardPage = lazy(() => import("~/pages/GiftCardPage"))
const ListPage = lazy(() => import("~/features/lists/list/page"))
const ListsPage = lazy(() => import("~/features/lists/page"))

export function useRegularRoutes(): RouteObject[] {
  const { t } = useTranslation("urls")
  const { country } = useBaseConfig()

  return [
    {
      element: <Layout whiteBg />,
      children: [
        {
          path: `${t("/verification")}/:type`,
          element: <VerificationPage />,
        },
        {
          path: t("/orderstatus"),
          element: <PurchaseStatusPage />,
        },
        {
          path: t("/unsubscribe"),
          element: <UnsubscribePage />,
        },
        {
          path: t("/service-and-contact/contact"),
          element: <ContactPage />,
        },
        {
          path: t("/verify-cash-register-registration"),
          element: <VerifyCashRegisterRegistrationPage />,
        },
        {
          path: t("/register-loyalty-card"),
          element: <Navigate to={`${t("/login")}?method=passwordless`} />,
        },
        {
          path: t("/giftcard"),
          element: <GiftCardPage />,
        },
      ].map((route) => routeMapper(country, route)),
    },
    {
      element: <Layout />,
      children: [
        {
          path: t("/newsletter/subscribe"),
          element: <NewsletterSubscribePage />,
        },
        {
          path: t("/sign-up/success"),
          element: <SignUpSuccessPage />,
        },
        {
          path: t("/loyalty-to-discount"),
          element: <LoyaltyPointsToDiscountPage />,
        },
      ].map((route) => routeMapper(country, route)),
    },
    {
      element: <GuestLayout />,
      children: [
        {
          path: t("/lists"),

          children: [
            {
              element: <ListsPage />,
              index: true,
            },
            {
              path: `${t("/lists")}/:listId`,
              element: <ListPage />,
            },
          ],
        },
      ],
    },
  ]
}
